import React, { useState, useEffect, useContext } from "react";
import ApiService from "../api/ApiService";
import notification from "../helpers/notification";
import { ToastContainer } from "react-toastify";
import MonthDropdown from "../components/common/MonthDropdown";
import YearDropdown from "../components/common/YearDropdown";
import AppContext from "../context/AppContext";
import { useTranslation } from "react-i18next";
import "../css/RecordingOfScores.css";
import "../css/app.css";
import { Image, OverlayTrigger, Tooltip } from "react-bootstrap";
import i18n from "../i18n";

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const RecordingOfPledge = () => {
  const { t } = useTranslation();
  const { user } = useContext(AppContext);
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [currentMonth, setCurrentMonth] = useState(
    monthNames[new Date().getMonth()]
  );
  const [submissionYear, setSubmissionYear] = useState(
    new Date().getFullYear()
  );
  const [submissionMonth, setSubmissionMonth] = useState(
    monthNames[new Date().getMonth()]
  );
  const [harinamCounts, setHarinaamCounts] = useState(0);
  const [harinamCount, setHarinaamCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState("Regular Update");
  const [isPledgeSubmitted, setIsPledgeSubmitted] = useState(false);

  const getPledgeCountData = async (user) => {
    try {
      // Use submissionYear and currentMonth for API call
      const yearToFetch = submissionYear;
      const monthToFetch = monthNames.indexOf(currentMonth) + 1; // Convert month name to number
  
      console.log("SENTYEAR", yearToFetch, "SENTMONTH", monthToFetch);
  
      const res = await ApiService.fetchPledgeCount(
        user.temple_id,
        "Regular Update",
        false,  // Assuming 'isTemple' should be true, or adjust based on your logic
        yearToFetch,
        monthToFetch
      );
  
      console.log("RESSSS", res);
  
      // Count for the selected year and month
      const count =
        Array.isArray(res) && res.length > 0
          ? parseInt(res[0]?.count_book, 10) || 0
          : 0;
  
      setHarinaamCounts(count);
  
      // Filter for pledge data for the selected month and year
      const pledgeData = res.filter(
        (item) =>
          item.month === monthToFetch && item.year === yearToFetch
      );
  
      const isSubmitted = pledgeData.length > 0;
      setIsPledgeSubmitted(isSubmitted);
  
      if (isSubmitted) {
        const remainingMonths = 12 - monthToFetch;
        const monthlyPledge = Math.floor(count / remainingMonths);
        setHarinaamCount(monthlyPledge);
      } else {
        setHarinaamCount(0);
      }
    } catch (error) {
      console.error("Error fetching pledge counts", error);
      setHarinaamCounts(0);
    }
  };
  
  

  //Save Pledge for the rest of the months
  const handleRecordingPledgeSave = async () => {
    if (!harinamCount || harinamCount <= 0) {
      notification(
        "warning",
        t("Please enter a valid Harinaam Sankirtan count.")
      );
      return;
    }

    const currentDate = new Date();
    const currentMonthIndex = currentDate.getMonth(); // 0-based index
    const monthsToSubmit = monthNames.slice(currentMonthIndex); // From current month to December

    const data = monthsToSubmit.map((monthName, index) => ({
      month: currentMonthIndex + index + 1, // 1-based month (May = 5)
      year: submissionYear,
      book_id: "Harinaam Sankirtan",
      count_book: harinamCount,
      total_points: harinamCount * 0.25,
      user_id: user.id,
      user_name: user.name,
      hindiname: user.hindiname,
      temple_id: user.temple_id,
      temple_name: user.temple_name,
      state_id: user.state_id,
      state_name: user.state_name,
      zone: user.zone_name,
      event: "Regular Update",
    }));

    try {
      setLoading(true);
      await ApiService.recordingPledgeScoreSubmit(data);
      notification("success", t("Pledge Submitted Successfully"));
      getPledgeCountData(user); // Refresh current data
    } catch (err) {
      console.error(err);
      notification(
        "error",
        err.response?.data?.message || t("Submission failed")
      );
    } finally {
      setLoading(false);
    }
  };

  //component re-render when any of the following changes.
  useEffect(() => {
    if (user) {
      getPledgeCountData(user);
    }
  }, [user, currentMonth, currentYear, submissionYear]);

  return (
    <>
      <ToastContainer />
      <div className="container common-container pledge-responsive">
        {/* Header */}
        <div className="update-score-container card card-top card-shadow">
          <div className="card-body">
            <h5 className="card-title">{t("Submit Your Pledge")}</h5>
            <p className="card-text">
              {t(
                "Commit to spreading the holy names! Submit your monthly Harinaam Sankirtan pledge and help track your spiritual contribution. Your dedication supports the collective mission of chanting across the nation."
              )}
            </p>
          </div>
        </div>
        {/* Main Body */}
        <div className="update-score-container mt-4">
          <div className="row">
            {/* Left Div */}
            <div className="col-6">
              <div className="profile-left">
                {/* <div className="profile-image">
                  <div className="">
                    <p className="m-0 contact-us-text">
                      {t("Important Information")}
                    </p>
                  </div>
                </div> */}
                <div className="contact-us-image">
                  <Image
                    src="/images/common/sankirtan.jpeg"
                    alt="Sankirtan"
                    style={{
                      width: "100%",
                      height: "300px", // or any fixed height you want
                      objectFit: "contain",
                    }}
                    fluid
                  />
                </div>
                <p className="contact-description">
                {i18n.language === "hi" ? (
                    <>
                      {t(
                        "एक बार सबमिट करने के बाद संकल्पों को संपादित नहीं किया जा सकता है। कृपया"
                      )}{" "}
                      <a
                        href="/contact-us"
                        style={{ textDecoration: "underline" }}
                      >
                        {t("यहां क्लिक करें")}
                      </a>{" "}
                      {t("अधिक जानकारी के लिए")}
                    </>
                  ) : (
                    <>
                      {t("Pledges cannot be edited after submission. Please")}{" "}
                      <a
                        href="/contact-us"
                        style={{ textDecoration: "underline" }}
                      >
                        {t("click here")}
                      </a>{" "}
                      {t("for more information")}
                    </>
                  )}
                </p>
              </div>
            </div>
            {/* Right Div */}
            <div className="col-6">
              <div className="content-table">
                <div className="d-flex justify-content-between">
                  <div className="table-description">
                    <h3 className="content-title">{t("Submit Your Pledge")}</h3>
                    <p className="text-muted text-main-class">
                      {t("Submit your monthly Harinaam Sankirtan pledge")}
                    </p>
                  </div>
                </div>
                <hr />
                <div className="card-body">
                  <div className="row mb-3 d-flex justify-content-between">
                    <div className="col-md-5 fw-medium mobile-font">
                      {t("Year")}
                    </div>
                    <div className="col-md-4">
                      <YearDropdown
                        selectedYear={submissionYear}
                        setSelectedYear={setSubmissionYear}
                      />
                    </div>
                  </div>
                  <div className="row mb-3 d-flex justify-content-between">
                    <div className="col-md-5 fw-medium mobile-font">
                      {t("Your Monthly Pledge")}
                    </div>
                    <div className="col-md-4">
                      <input
                        type="number"
                        min={0}
                        max={1000}
                        className="form-control"
                        value={harinamCount === 0 ? "" : harinamCount}
                        onChange={(e) => {
                          let val = e.target.value;
                          let num = Number(val);
                          if (num > 1000) num = 1000;
                          setHarinaamCount(val === "" ? 0 : num);
                        }}
                        onBlur={(e) => {
                          if (e.target.value === "") setHarinaamCount(0);
                        }}
                        disabled={isPledgeSubmitted}
                        style={{
                          textAlign: "center",
                          fontSize: window.innerWidth > 768 ? "18px" : "13px",
                        }}
                      />
                    </div>
                  </div>
                  <div className="row mb-3 d-flex justify-content-between">
                    <div className="col-md-6 fw-medium mobile-font">
                      {t("Total Pledge Count (Year)")}
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id="tooltip-top">
                            Total Pledge of the year is calculated based on the
                            remaining number of months for the calendar year.
                          </Tooltip>
                        }
                      >
                        <span
                          className="tooltip-icon"
                          style={{
                            cursor: "pointer",
                            marginLeft: "8px",
                            fontSize: "1.2rem",
                            textDecoration: "none",
                          }}
                        >
                          <i className="bi bi-info-circle"></i>
                        </span>
                      </OverlayTrigger>
                    </div>
                    <div className="col-md-4">
                      <div className="form-control bg-light text-dark d-flex justify-content-center align-items-center mobile-font">
                        {isPledgeSubmitted
                          ? harinamCounts
                          : harinamCount * (12 - new Date().getMonth())}{" "}
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="d-flex justify-content-between align-items-center">
                  <button
                    className="btn-primarysave custom-button"
                    onClick={handleRecordingPledgeSave}
                    disabled={loading || isPledgeSubmitted} // Disable if pledge is already submitted
                  >
                    {t("Save Pledge")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RecordingOfPledge;
